import {getBarWidth} from './getBarWidth.js';

const SCROLL_BUFFER_LENGTH = 140;
const MIN_X_SCALE = 0.1;

export const onScale = ({
    xScale,
    setArrangementXScale,
    arrangementContainer,
    x,
    cursorStep,
    resolution
}) => {
    if (xScale < MIN_X_SCALE || xScale > 5) {
        return;
    }
    
    // first scroll then do the thang
    let width = getBarWidth(cursorStep, resolution, xScale);
    let scrollLeft = width - x + SCROLL_BUFFER_LENGTH;
    setArrangementXScale(xScale);
    arrangementContainer.current.scrollTo(scrollLeft, 0);
};
